import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AppointmentList from './AppointmentList';
import AppointmentForm from './AppointmentForm';
import AppointmentIndividual from './AppointmentIndividual';

const AppointmentRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AppointmentList />} />
      <Route path="/new" element={<AppointmentForm />} />
      <Route path="/edit/:id" element={<AppointmentForm />} />
      <Route path="/my-schedule" element={<AppointmentIndividual />} />

    </Routes>
  );
};

export default AppointmentRoutes; 